function NewBook({color}) {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
      style={{ msFilter: "" }}
      fill={color || "rgba(0, 0, 0, 1)"}
    >
      <path d="M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"></path>
      <path d="M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"></path>
    </svg>
    )
  }
  
  export default NewBook;
  